module.exports = __webpack_public_path__ + "static/thumbnail-privileged-09311adc2e10b09ea3e6c0d497fc4e72.png";